import moment from "moment";
import React from "react";
import { useImperativeHandle } from "react";
import { useEffect } from "react";
import { useState } from "react";
import appApi from "../../../lib/app-api";
import util from "../../../lib/util";
import LoadingPanel from "../../shared/loading-panel";
import { PTO_LEGEND_WEIGHT } from "../pto-consts";
import PtoDetailBox from "./pto-detail-box";
import PtoLinkLabel from "./pto-link-label";
import PtoMoreBox from "./pto-more-box";
import PtoStatusLabel from "./pto-status-label";
import { dateKey, itemClass, PTO_LEGEND_COLOR_MAP, VIEW_STATUS } from "./_common";


/**
 * @typedef {{
 *  startDate: import("moment").Moment,
 *  endDate: import("moment").Moment
 * }} DateRange
 * 
 * @typedef {{
 *  date: import("moment").Moment,
 *  slots: boolean[],
 *  externalItems: object[],
 *  hidExternals: object[],
 *  calendarItems: object[],
 *  available: number,
 * }} CellMetadata
 */

const _slotHeight = 26;
const _commonCellClass = "pto-calendar-month-cell";
const _commonHeaderCellClass = "pto-calendar-month-header-cell";
const _normalLeft = "0% 100%, 0% 0%";
const _normalRight = "100% 0%, 100% 100%";
const _arrowLeft = "5px 100%, 0% 50%, 5px 0%";
const _arrowRight = "calc(100% - 5px) 0%, 100% 50%, calc(100% - 5px) 100%";


export const MonthCalendarItem = (props) => {

    const { showSingle, flexGrow, viewSettings, item, dateRange, employee, onCancel, onApprove, onDeny, onConsultHR, date, ...rest } = props;
    const typeCode = item.typeCode;
    const color = PTO_LEGEND_COLOR_MAP[typeCode].color;
    const lighterColor = util.pSBC(PTO_LEGEND_WEIGHT.Lighter, color);
    const borderColor = util.pSBC(PTO_LEGEND_WEIGHT.DarkerBorder, color);

    const mDate = moment(date);
    const itemLength = item.length - Math.abs(mDate.diff(moment(item.startDate), "day"));
    const endDate = moment(mDate).add(itemLength - 1, "day");
    const width = showSingle ? "100%" : `calc(${itemLength * 100}% + ${itemLength - 5}px)`;
    
    return (
        <PtoDetailBox {...props} employee={employee} calendarItem={item}>
            <div title={item.title} style={{ width: width, display: "flex", flexGrow: flexGrow !== undefined ? flexGrow : 1, flexDirection: "column" }}>
                <div style={_getContainerBorderStyle()}
                    className={itemClass(item)}>
                    <div className="pto-month-view-item" style={_getContainerStyle()}
                        onMouseEnter={() => $(`.${itemClass(item)}`).addClass("pto-item-highlight")}
                        onMouseLeave={() => $(`.${itemClass(item)}`).removeClass("pto-item-highlight")}>
                        {showSingle ? null : <PtoLinkLabel hidden={!!!item.previousDate || mDate.isSame(moment(item.previousDate), "week")} hideDate={itemLength <= 1} date={item.allStartDate} direction="left" />}
                        <div className="title" style={{ flexGrow: 1 }}>{employee.fullName}</div>
                        <div className="title" style={{ flexGrow: 1, textAlign: "right", paddingRight: 15 }}>{item.typeCode}</div>
                        <PtoStatusLabel hideLabel pto={item.pto} />
                        {showSingle ? null : <PtoLinkLabel hidden={!!!item.nextDate || mDate.isSame(moment(item.nextDate), "week")}  hideDate={itemLength <= 1} date={item.allEndDate} direction="right" />}
                    </div>
                </div>
            </div>
        </PtoDetailBox>
    );

    function _getContainerStyle() {
        const style = {
            backgroundColor: lighterColor,
            margin: 1,
            flexGrow: 1,
            display: "flex",
            flexDirection: "row"
        };

        let leftSide = _normalLeft;
        let rightSide = _normalRight;

        if (!showSingle) {
            if (item.previousDate) {
                leftSide = _arrowLeft;
            } else {
                style.marginLeft = 5;
            }

            if (item.nextDate) {
                rightSide = _arrowRight;
            }
        }

        style.clipPath = `polygon(${leftSide}, ${rightSide})`;

        return style;
    }

    function _getContainerBorderStyle() {
        const style = {
            backgroundColor: borderColor,
            margin: 2,
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            zIndex: 2,
            height: _slotHeight,
            width: "100%"
        };

        let leftSide = _normalLeft;
        let rightSide = _normalRight;
        if (!showSingle) {
            if (item.previousDate) {
                leftSide = _arrowLeft;
            }

            if (item.nextDate) {
                rightSide = _arrowRight;
            }
        }
        style.clipPath = `polygon(${leftSide}, ${rightSide})`;

        return style;
    }
}

const PtoMonthCell = (props) => {
    /**
     * @type {{
     *  month: import("moment/moment").Moment,
     *  date : import("moment/moment").Moment,
     *  col: number,
     *  row: number,
     *  metadataMap: Map<string, CellMetadata>,
     *  calendarItems: object[]
     * }}
     */
    const { month, date, metadataMap, calendarItems, col, row, employeeMap } = props;
    const isToday = moment().isSame(date, "day");
    const isInMoth = date.isSame(month, "month");
    const key = dateKey(date);
    if (!metadataMap.has(key)) metadataMap.set(key, _newMetadata());
    const metadata = metadataMap.get(key);

    const allITems = [...calendarItems, ...metadata.hidExternals];
    const drawn = [];
    const hidItems = [];

    allITems.forEach((v, i) => {
        if (i < metadata.available) drawn.push(allITems[i]);
        else hidItems.push(allITems[i]);

    });

    let slotIdx = 0;
    drawn.forEach(item => {
        const mStartDate = moment(item.startDate);
        const d = moment(date);
        const remain = item.length - Math.abs(d.diff(mStartDate, "day"));

        while (!metadata.slots[slotIdx]) slotIdx++;
        for (let i = 0; i < remain; i++) {
            const k = dateKey(d);
            if (k != key) {
                if (!metadataMap.has(k)) metadataMap.set(k, _newMetadata());
                const m = metadataMap.get(k);
                m.available -= 1;
                m.externalItems.push(item);
                m.slots[slotIdx] = false;
            }
            d.add(1, "day");
        }
        slotIdx++;
    })

    hidItems.forEach(item => {
        const mStartDate = moment(item.startDate);
        const d = moment(date);
        const remain = item.length - Math.abs(d.diff(mStartDate, "day"));
        if (remain > 1) {
            let sIdx = 0;
            d.add(1, "day")
            const k = dateKey(d);

            if (!metadataMap.has(k)) metadataMap.set(k, _newMetadata());
            const m = metadataMap.get(k);

            m.hidExternals.push(item);
        }
    });

    const moreItems = hidItems.length;
    const moreClass = hidItems.reduce((a, v, i) => { a.push(itemClass(v)); return a }, []);

    const moreListStyle = {
        width: 300,
        height: 400,
        positon: "absolute",
        backgroundColor: "white",
        marginLeft: -250,
        marginTop: -100,
        overflowY: "scroll",
        border: "2px solid #CCC",
        borderRadius: 5,
        padding: 10,
        boxShadow: "#666 0px 3px 5px"
    };

    let itemIdx = 0;

    return (
        <div className={_commonCellClass} style={{ gridColumn: col, gridRow: row, display: "flex", flexDirection: "column", backgroundColor: isInMoth ? "white" : "#EEE" }}>
            <div style={{ width: "100%", flexGrow: 0, textAlign: "center", padding: 5 }}>
                <div style={{
                    display: "inline-block",
                    borderRadius: "50%",
                    backgroundColor: isToday ? "green" : undefined,
                    color: isToday ? "white" : "inherit",
                    padding: "3px 1px",
                    width: 25, height: 25
                }}>{date.date()}</div>
            </div>
            <div style={{ height: 120, width: "100%", flexGrow: 1, overflowX: "visible" }}>
                {
                    metadata.slots.map((v, slotIdx) => {
                        if (v && itemIdx < drawn.length) {
                            const item = drawn[itemIdx++];
                            return <MonthCalendarItem key={`${key}_${slotIdx}`} date={date} {...props} item={item} employee={employeeMap.get(item.peopleId)} />
                        } else {
                            return <div key={`${key}_${slotIdx}`} style={{ width: 1, height: _slotHeight + 4, zIndex: -1 }}></div>
                        }
                    })
                }
            </div>

            <PtoMoreBox items={[...metadata.externalItems, ...drawn, ...hidItems]}
                        count={moreItems} moreClass={moreClass} dateKey={dateKey(date)}
                        employeeMap={employeeMap} itemProps={props} reserveSpace />          
        </div>
    );

    function _newMetadata() {
        return {
            available: 4,
            calendarItems,
            date: moment(date),
            hidExternals: [],
            externalItems: [],
            slots: [true, true, true, true]
        };
    }
}

const PtoMonthGrid = (props) => {

    /**
     * @type {Map<string, CellMetadata>}
     */
    const cellMetadata = new Map();

    /** @type {{
     *  dateRange: DateRange,
     *  calendarItems: Map<string, object>
     * }} */
    const { dateRange, viewSettings, calendarItems } = props;
    const { showWeekend } = viewSettings;
    return (
        <div style={{ display: "grid", gridAutoColumns: "1fr" }}>
            {_renderHeaders()}
            {_renderGrid()}
        </div>
    );

    function _renderGrid() {
        const calendarStart = moment(dateRange.startDate).startOf("week");
        const calendarEnd = moment(dateRange.endDate).endOf("week");

        const dayList = util.getAllDaysInRange(calendarStart, calendarEnd);
        let row = 1;

        return dayList.filter(d => showWeekend ? true : d.weekday() !== 0 && d.weekday() !== 6)
            .map(d => {
                const col = __columnRoll();
                const key = dateKey(d);
                const cellItems = calendarItems.has(key) ? calendarItems.get(key) : [];
                if (col === 1) row++;
                return (
                    <PtoMonthCell key={dateKey(d)} {...props} month={moment(dateRange.startDate).startOf("month")}
                        date={d} col={col} row={row} calendarItems={cellItems} metadataMap={cellMetadata}>
                    </PtoMonthCell>
                );
            });
    }

    function _renderHeaders() {
        return [
            showWeekend ? <div className={_commonHeaderCellClass} key="h_Sun" style={{ gridColumn: __columnRoll(), gridRow: 1 }}><div style={{ flexGrow: 1 }}>Sunday</div></div> : null,
            <div key="h_Mon" className={_commonHeaderCellClass} style={{ gridColumn: __columnRoll(), gridRow: 1 }}><div style={{ flexGrow: 1 }}>Monday</div></div>,
            <div key="h_Tue" className={_commonHeaderCellClass} style={{ gridColumn: __columnRoll(), gridRow: 1 }}><div style={{ flexGrow: 1 }}>Tuesday</div></div>,
            <div key="h_Wed" className={_commonHeaderCellClass} style={{ gridColumn: __columnRoll(), gridRow: 1 }}><div style={{ flexGrow: 1 }}>Wednesday</div></div>,
            <div key="h_Thu" className={_commonHeaderCellClass} style={{ gridColumn: __columnRoll(), gridRow: 1 }}><div style={{ flexGrow: 1 }}>Thursday</div></div>,
            <div key="h_Fri" className={_commonHeaderCellClass} style={{ gridColumn: __columnRoll(), gridRow: 1 }}><div style={{ flexGrow: 1 }}>Friday</div></div>,
            showWeekend ? <div key="h_Sat" className={_commonHeaderCellClass} style={{ gridColumn: __columnRoll(), gridRow: 1 }}><div style={{ flexGrow: 1 }}>Saturday</div></div> : null
        ];
    }

    function __columnRoll() {
        const modFactor = viewSettings.showWeekend ? 7 : 5;
        const col = __columnRoll._col_ || (__columnRoll._col_ = 0);
        __columnRoll._col_ = (++(__columnRoll._col_)) % modFactor;
        return col + 1;
    }
}


const PtoMonthCalendar = React.forwardRef((props, ref) => {
    const [errorMessage, setErrorMessage] = useState("");
    const [viewStatus, setViewStatus] = useState(VIEW_STATUS.Loaded);
    const [calendarItems, setCalendarItems] = useState(new Map());

    const [employeeMap, setEmployeeMap] = useState(props.employees.reduce((m, e) => {
        m.set(e.peopleId, e);
        return m;
    }, new Map()));

    useImperativeHandle(ref, () => ({
        reload: () => {
            setViewStatus(VIEW_STATUS.Loading);
            _initializeAsync();
        }
    }));

    useEffect(() => {
        setViewStatus(VIEW_STATUS.Loading);
        setEmployeeMap(props.employees.reduce((m, e) => {
            m.set(e.peopleId, e);
            return m;
        }, new Map()));
        _initializeAsync();
    }, [props.dateRange.startDate.month(), props.employees]);

    switch (viewStatus) {
        case VIEW_STATUS.Loaded:
            return _renderLoaded();
        case VIEW_STATUS.Error:
            return _renderError();
        default:
            return _renderLoading();
    }

    async function _initializeAsync() {
        const { employees, dateRange, ...rest } = props;
        const peopleIdList = employees.map(e => e.peopleId);
        const req = {
            peopleIdList,
            startDate: moment(dateRange.startDate).startOf("week").format("YYYY-MM-DD"),
            endDate: moment(dateRange.endDate).endOf("week").format("YYYY-MM-DD")
        };

        try {
            const res = await appApi.loadTimeOffItemByPeopleAndDateRangeAsync(req);
            const items = res.data.items || [];
            const itemMap = items.reduce((map, item) => {
                const key = dateKey(item.startDate);
                if (!map.has(key)) map.set(key, []);
                map.get(key).push(item);
                return map;
            }, new Map());
            setCalendarItems(itemMap);
            setViewStatus(VIEW_STATUS.Loaded);
        } catch (err) {
            console.error(err);
            setViewStatus(VIEW_STATUS.Error);
            setErrorMessage("Error while loading PTO data.");
        }
    }

    function _renderLoading() {
        return (
            <div className="text-center">
                <div>
                    <LoadingPanel message="Loading. Please wait..." />
                </div>
            </div>
        );
    }

    function _renderLoaded() {
        const width = `${(100 / 7).toFixed(2)}%`
        return (
            <PtoMonthGrid {...props} calendarItems={calendarItems} employeeMap={employeeMap} />
        );
    }

    function _renderError() {
        return (
            <div className="alert alert-danger text-left">
                {errorMessage}
            </div>
        );
    }
});

export default PtoMonthCalendar;